import { render, staticRenderFns } from "./MarketAreaTabTable.vue?vue&type=template&id=3d7967ce&scoped=true"
import script from "./MarketAreaTabTable.vue?vue&type=script&lang=js"
export * from "./MarketAreaTabTable.vue?vue&type=script&lang=js"
import style0 from "./MarketAreaTabTable.vue?vue&type=style&index=0&id=3d7967ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7967ce",
  null
  
)

export default component.exports